export const EMPTY_STRING = ""
export const UNKNOW_STRING = "unknow"

export function isEmptyString(str) {
    return str === ""
}